<template>
  <div>
    <div class="row">
      <h4 class="col-md-4">時間查詢:</h4>
    </div>
    <div class="row">
      <el-row :gutter="20">
        <el-col :span="6">
          <h4 class="col-md-3">月份：</h4>
          <el-date-picker
            v-model="searchMonth"
            type="month"
            placeholder="選擇月份"
            value-format="yyyy-MM"
            @change="changeSearchMonth"
          ></el-date-picker>
        </el-col>
        <el-col :span="6">
          <FilterOption
            :options="options"
            @selectFilter="selectFilter"
          ></FilterOption>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="directInvoicePage">
            新增請款單
          </el-button>
        </el-col>
      </el-row>
    </div>
    <hr />
    <el-row>
      <el-col>
        <FilterTag ref="filterTag" @searchList="searchList"></FilterTag>
      </el-col>
    </el-row>
    <hr />
    <InvoiceTable
      :task="task"
      :invoiceList="invoiceList"
      :total="total"
      @updateInvoice="getEnterpriseInvoiveList"
      @nextPage="invoiceNextPage"
    ></InvoiceTable>
    <AddInvoiceModal
      ref="addInvoiceModal"
      @updateInvoiceList="getEnterpriseInvoiveList"
      :companyList="enterpriseList"
    ></AddInvoiceModal>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'

import InvoiceTable from './InvoiceTable'
import AddInvoiceModal from '../../components/company/AddInvoiceModal'
import InputAutocomplete from '../element_ui/InputAutocomplete'
import RolesRadioButton from '../element_ui/RolesRadioButton'
import RequestRadioButton from '../element_ui/RequestRadioButton'
import FilterOption from '../element_ui/filter_componet/Filter'
import FilterTag from '../element_ui/filter_componet/Tag'
export default {
  // props:['companyList'],
  components: {
    InvoiceTable,
    AddInvoiceModal,
    InputAutocomplete,
    RolesRadioButton,
    RequestRadioButton,
    FilterOption,
    FilterTag,
  },
  data() {
    return {
      total: 0,
      kw: '',
      dateNum: 0,
      task: 'enterprise',
      driverId: 0,
      invoiceList: [],
      enterpriseList: [],
      enterpriseId: 0,
      driverList: [],
      searchMonth: '',
      options: [],
      filter: '',
      npp: 25,
      page: 1,
    }
  },
  mounted() {
    this.options = [
      {
        value: 'is_payment',
        label: '是否結單',
        children: [
          {
            value: 'false',
            label: '否',
          },
          {
            value: 'true',
            label: '是',
          },
        ],
      },
    ]
    this.getEnterpriseList()
    this.getEnterpriseInvoiveList()
  },
  methods: {
    invoiceNextPage(page) {
      this.page = page
      this.getEnterpriseInvoiveList()
    },
    searchList(val) {
      //console.log(val)
      this.filter = ''
      for (let i = 0; i < val.length; i++) {
        this.filter = this.filter + `&${val[i].key}=${val[i].value}`
      }
      this.getEnterpriseInvoiveList()
    },
    selectFilter(val) {
      this.$refs.filterTag.setTag(val)
    },
    clearData() {
      this.invoiceList = []
      this.searchMonth = null
      this.kw = ''
      this.driverList = []
      this.driverId = 0
      this.enterpriseId = 0
    },
    changeSearchMonth(month) {
      let object = {
        key: 'search_month',
        title: `篩選時間: ${month}`,
        value: month,
      }
      this.selectFilter(object)
    },
    showEnterpriseTable() {
      this.clearData()
      this.task = 'enterprise'
    },
    directInvoicePage() {
      this.$refs.addInvoiceModal.showModal()
    },
    getEnterpriseInvoiveList() {
      EnterpriseAPI.get(
        `enterprise/invoice/v2?npp=${this.npp}&page=${this.page}${this.filter}`,
      )
        .then((res) => {
          let { count, invoiceList } = res.result
          //console.log(count)

          this.total = Math.ceil(count / this.npp)
          //console.log(this.total)

          this.invoiceList = invoiceList
        })
        .catch((err) => {
          this.$msg('目前無請款單')
          console.error(err)
        })
    },
    getEnterpriseList() {
      EnterpriseAPI.get(`enterprise`)
        .then((res) => {
          const { list } = res.result
          this.enterpriseList = list
        })
        .catch((err) => {
          this.$msg(err.message)
        })
    },
  },
}
</script>
<style scoped>
.input-interval {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/company/InvoiceList.vue